const React = window.React || null;

const { useEffect } = React;

export default function LogoAdw() : React.ReactElement {

    const ref = React.createRef<HTMLDivElement>();
    
    // Always use SVG logo for mobile menu (never use GIF)
    const elLogoIconMarkup = React.useMemo(() => {
        // Always use the SVG logo for mobile menu
        const svgElement = document.getElementById('aw-logo-svg');
        if (svgElement) {
            // Clone SVG and ensure it's visible in modal
            const cloned = svgElement.cloneNode(true) as HTMLElement;
            cloned.classList.remove('d-none', 'd-lg-none');
            cloned.style.display = 'block';
            cloned.style.visibility = 'visible';
            cloned.removeAttribute('id'); // Remove ID to prevent conflicts
            return cloned.outerHTML;
        }
        return '';
    }, []);

    // Copy the Icon markup from page DOM and insert it into this React component
    useEffect(() => {

        if( ref?.current && typeof window?.anime === 'function' ){
            const paths = ref.current?.querySelectorAll('path');
            // Only animate if it's an SVG (has paths), not an image
            if (paths && paths.length > 0) {
                ref.current.style.visibility = 'visible';
                anime.timeline()
                    .add({
                        targets: paths,
                        opacity: [1, 0],
                        // translateX: [0, -5],
                        duration: 400,
                        easing: 'easeInOutQuad',
                        delay: anime.stagger(35),
                    })
                    .add({
                        targets: paths,
                        opacity: [0, 1],
                        // translateX: [-5, 0],
                        duration: 500,
                        easing: 'easeInOutQuad',
                        delay: anime.stagger(35),
                    }, '-=150')
            } else {
                // For images (GIF), just make visible
                ref.current.style.visibility = 'visible';
            }
        }
        
    }, [ref]);

    return (
        <div>
            {/* Insert the logo markup here (SVG or GIF) */}
            <div id="modal-adw-logo" ref={ref} dangerouslySetInnerHTML={{__html: elLogoIconMarkup}}
                style={{ visibility: 'hidden', position: 'relative', zIndex: 100005 }}
            >
                {/* Insert HTML Dynamically */}
            </div>
        </div>
    )
}